export const Tracking = {
    Storage: {
        ATTRIBUTION_KEY: "relode:tracking:attribution:key",
        SPONSOR_KEY: "relode:tracking:sponsor:key",
        EXPIRE_DAYS: 30
    }
};
